import S from './SkeletonStyles';

function ItemsListSkeleton({ length }: { length?: number }): JSX.Element {
  const emptyArray = Array.from({ length: length || 10 });
  return (
    <>
      {
        emptyArray.map((row, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <S.Row key={index}>
            <div className="overview-skeleton" />
          </S.Row>
        ))
      }
    </>
  );
}

export default ItemsListSkeleton;
